<template>
  <div class="md-drawer-trigger">
    <button class="drawer-btn" @click.stop="handleOpen">
      <i class="el-icon-folder-opened"></i>
      {{ title || $t('workbench.openDetail') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'MdDrawer',
  props: {
    type: { type: String, default: 'form' },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    content: { type: String, default: '' },
    btnText: { type: String, default: '' },
    action: { type: String, default: '' },
    formConfig: { type: String, default: '' },
    fields: { type: String, default: '' },
    api: { type: String, default: '' },
    formApi: { type: String, default: '' },
    formType: { type: String, default: '' },
    url: { type: String, default: '' },
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    drawerWidth: { type: String, default: '' },
    loading: { type: String, default: '' },
    cardScopeKey: { type: String, default: '' },
    isHistory: { type: Boolean, default: false },
    messageId: { type: String, default: '' },
    _componentKey: { type: String, default: '' },
    tableData: { type: String, default: '' },
    columns: { type: String, default: '' },
    _rawJson: { type: String, default: '' }
  },
  mounted() {
    // 非历史记录时，自动打开抽屉（每次 mounted 都会触发，重置状态确保新内容生效）
    if (!this.isHistory) {
      // 视图切换后重新挂载时，如果该抽屉的 action 已被提交过（cardSelections 中有记录），
      // 则不重复打开，避免用户切回智擎工作台时旧的抽屉自动展开
      if (this.action) {
        // 使用与 CosmoClawDrawer.drawerScopeKey 相同的默认 scope 格式
        const scopeKey = `${this.cardScopeKey || 'global'}::${this.action}`
        if (this.$store.state.cosmoClaw.cardSelections[scopeKey] !== undefined) return
      }
      this.openDrawer()
    }
  },
  methods: {
    openDrawer() {
      // 1. 从 _rawJson 解析所有原始 props（包括 cardListData、attribute、skillTitle、multiple 等）
      let rawProps = {}
      if (this._rawJson) {
        try {
          rawProps = JSON.parse(this._rawJson)
          delete rawProps._componentKey
          delete rawProps._rawJson
        } catch (e) { /* ignore */ }
      }

      // 2. 提取 formConfig（优先使用 this.formConfig/fields，其次从 _rawJson 提取）
      let formConfigStr = this.formConfig || this.fields
      if (!formConfigStr && rawProps.formConfig) {
        formConfigStr = typeof rawProps.formConfig === 'string'
          ? rawProps.formConfig
          : JSON.stringify(rawProps.formConfig)
      }
      if (!formConfigStr) {
        // 最后一次兜底：从 _rawJson 原始字符串重新解析
        const fc = rawProps.formConfig || rawProps.fields
        if (fc) formConfigStr = typeof fc === 'string' ? fc : JSON.stringify(fc)
      }

      // 3. 构建最终 config：以 _rawJson 中所有原始 props 为基础，显式声明的 props 覆盖
      this.$store.commit('cosmoClaw/SET_DRAWER_CONFIG', {
        ...rawProps,
        // 显式声明的 props 覆盖 _rawJson 中的值（确保组件实例上当前的值优先）
        type: this.type || 'form',
        title: this.title,
        description: this.description || this.content || '',
        action: this.action,
        formConfig: formConfigStr || '',
        btnText: this.btnText,
        formApi: this.formApi,
        formType: this.formType,
        url: this.url,
        width: this.width,
        height: this.height,
        drawerWidth: this.drawerWidth,
        loading: this.loading,
        tableData: this.tableData,
        columns: this.columns,
        cardScopeKey: this.cardScopeKey || this._componentKey || '',
        messageId: this.messageId || ''
      })
      this.$store.commit('cosmoClaw/SET_DRAWER_VISIBLE', true)
    },
    handleOpen() {
      this.openDrawer()
    }
  }
}
</script>

<style lang="scss" scoped>
.md-drawer-trigger {
  margin: 8px 0;
}

.drawer-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  color: #1f2329;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;

  i { font-size: 14px; color: #3370ff; }
  &:hover { border-color: #3370ff; color: #3370ff; }
}
</style>
